export enum DrawerType {
  Alerts = 'Alerts',
  SiteDetails = 'SiteDetails',
  LineDetails = 'LineDetails',
  BlockDetails = 'BlockDetails',
  ExecSummarySiteDetails = 'ExecSummarySiteDetails',
  ExecSummaryLineDetails = 'ExecSummaryLineDetails',
  GroupTypeList = 'GroupTypeList',
}
